import Hero1 from './Hero1';
import Hero1Para from './Hero1Para';
// import Hero2 from './Hero2';
// import Hero3 from './Hero3';
import Hero4 from './Hero4';
import Hero5 from './Hero5';
import Hero6 from './Hero6';
import Hero7 from './Hero7';
import Hero8 from './Hero8';
import Hero9 from './Hero9';
import Hero10 from './Hero10';
import Hero11 from './Hero11';
import Hero12 from './Hero12';
import Hero13 from './Hero13';
import Hero14 from './Hero14';
import Hero15 from './Hero15';
import Hero16 from './Hero16';
import Hero17 from './Hero17';
import Hero18 from './Hero18';
import Hero19 from './Hero19';
import Hero20 from './Hero20';
import Hero21 from './Hero21';
import Hero22 from './Hero22';
import Hero23 from './Hero23';
import Hero24 from './Hero24';
import Hero25 from './Hero25';
import Hero26 from './Hero26';
import Hero27 from './Hero27';

export {
  Hero1,
  Hero1Para,
  // Hero2,
  // Hero3,
  Hero4,
  Hero5,
  Hero6,
  Hero7,
  Hero8,
  Hero9,
  Hero10,
  Hero11,
  Hero12,
  Hero13,
  Hero14,
  Hero15,
  Hero16,
  Hero17,
  Hero18,
  Hero19,
  Hero20,
  Hero21,
  Hero22,
  Hero23,
  Hero24,
  Hero25,
  Hero26,
  Hero27
};
